export class EmitterObject {
    // #region Vars
    all = new Map();
    allAsync = new Map();
    nested = [];
    parent = null;
    // #endregion
    // #region Constructor
    constructor(all, parent) {
        this.all = all || new Map();
        this.parent = parent;
        if (this.parent) {
            this.parent.register(this);
        }
    }
    dispose() {
        this.all.clear();
        this.nested = [];
        if (this.parent) {
            this.parent.unregister(this);
        }
    }
    // #endregion
    // #region On, Off
    on(type, handler) {
        const handlers = this.all.get(type);
        const added = handlers && handlers.push(handler);
        if (!added) {
            this.all.set(type, [handler]);
        }
    }
    onAsync(type, handler) {
        const handlers = this.allAsync.get(type);
        const added = handlers && handlers.push(handler);
        if (!added) {
            this.allAsync.set(type, [handler]);
        }
    }
    off(type, handler) {
        const handlers = this.all.get(type);
        if (handlers) {
            handlers.splice(handlers.indexOf(handler) >>> 0, 1);
        }
    }
    offAsync(type, handler) {
        const handlers = this.allAsync.get(type);
        if (handlers) {
            handlers.splice(handlers.indexOf(handler) >>> 0, 1);
        }
    }
    // #endregion
    // #region nested
    register(nested) {
        if (!this.nested.includes(nested)) {
            this.nested.push(nested);
        }
    }
    unregister(nested) {
        if (!this.nested.includes(nested)) {
            let tIndex = this.nested.indexOf(nested);
            this.nested.splice(tIndex, 1);
        }
    }
    // #endregion
    // #region Emitt
    emit(type, evt) {
        //Self
        (this.all.get(type) || []).slice().map((handler) => { handler(evt); });
        (this.all.get('*') || []).slice().map((handler) => { handler(type, evt); });
        //Async
        (this.allAsync.get(type) || []).slice().map((handler) => { handler(evt); });
        (this.allAsync.get('*') || []).slice().map((handler) => { handler(type, evt); });
        //Nested
        if (this.nested) {
            this.nested.forEach(n => n.emit(type, evt));
        }
    }
    async emitAsync(type, evt) {
        // #region Self
        for (let tItem of (this.all.get(type) || []).slice()) {
            tItem(evt);
        }
        for (let tItem of (this.all.get('*') || []).slice()) {
            tItem(type, evt);
        }
        for (let tItem of (this.allAsync.get(type) || []).slice()) {
            await tItem(evt);
        }
        for (let tItem of (this.allAsync.get('*') || []).slice()) {
            await tItem(type, evt);
        }
        // #endregion
        // #region Nested
        if (this.nested) {
            for (let tNested of this.nested) {
                await tNested.emitAsync(type, evt);
            }
        }
        // #endregion	
    }
}
export default function mitt(all, parent) {
    return new EmitterObject(all, parent);
}
